module.exports = __webpack_public_path__ + "img/icon3_highlight.7f91120d.png";